import { Box } from 'grommet';
import React from 'react';

const Error = ({ error }: { error: Error }) => (
  <Box direction="row" border={{ color: 'red', size: 'large' }} pad="medium">
    {error.toString()}
  </Box>
);

export default Error;
